import { CopyOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Card, Form, Image, Modal, Popconfirm, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { MessagesService } from "services/Messages";
import initial_filter from "constants/InitialFilter";
import { ProductApi } from "api/ProductApi";
import { mainUrl } from "api/mainApiInstence";
import { FormComponent } from "./components/FormComponent";
import { formatCurrency } from "utils/formatCurrency";
import { CategoryApi } from "api/CategoryApi";

export default function Product() {
  // Table columns
  const columns = [
    {
      title: "ID",
      width: 100,
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (record, _) => {
        return (
          <Button
            type="link"
            onClick={() => {
              navigator.clipboard.writeText(record);
              MessagesService.success("Скопировано");
            }}
          >
            ID
            <CopyOutlined />
          </Button>
        );
      },
    },
    {
      title: "Название",
      width: 100,
      dataIndex: "name",
      key: "name",
      fixed: "left",
    },
    {
      title: "Цена",
      width: 100,
      dataIndex: "price",
      key: "price",
      fixed: "left",
      render: (record, _) => {
        return <span>{formatCurrency(record)}</span>;
      },
    },
    {
      title: "Фото",
      width: 130,
      dataIndex: "photos",
      key: "photos",
      render: (record, _) => {
        return (
          <Image
            className="rounded-lg"
            src={mainUrl() + "/files/" + record[0]}
            style={{
              height: "150px",
              objectFit: "contain",
            }}
          />
        );
      },
    },
    {
      title: "Действия",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (record) => {
        return (
          <div className="flex gap-x-2">
            <Button
              type="primary"
              ghost
              size="middle"
              onClick={() => {
                form.setFieldsValue(record);
                setFileList({
                  photos: record.photos.map((photo) => ({
                    url: `${mainUrl()}/files/${photo}`,
                  })),
                });
                setEdit(true);
              }}
            >
              Редактировать
              <EditOutlined />
            </Button>
            <Popconfirm
              title="Вы уверены, что хотите удалить этот продукт?"
              okText="Да"
              okType="danger"
              cancelText="Нет"
              size="middle"
              icon={<DeleteOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                onRemove(record.id);
              }}
            >
              <Button icon={<DeleteOutlined />} danger ghost size="middle">
                Удалить
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];
  // States
  const [data, setData] = useState();
  const [categories, setCategories] = useState();
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [fileList, setFileList] = useState({
    photos: [],
  });
  const [form] = Form.useForm();

  // Get portfolios
  useEffect(() => {
    setLoading(true);
    setBtnLoading(true);
    CategoryApi.get().then((res) => {
      if (res) {
        setCategories(res.categories);
      }
    });
    ProductApi.get(initial_filter)
      .then((res) => {
        setData(res.product);
        setBtnLoading(false);
        setLoading(false);
      })
      .catch((err) => {
        MessagesService.error(err.message);
        setLoading(false);
        setBtnLoading(false);
      });
  }, []);

  const onFinish = (values) => {
    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("price", values.price);
    formData.append("category_id", values.category_id);
    formData.append("description", values.description);
    if (values.sizes?.length) {
      formData.append("sizes", JSON.stringify(values.sizes));
    }
    if (values.photos.fileList?.length) {
      values.photos.fileList.forEach((file) => {
        formData.append("photos", file.originFileObj);
      });
    }
    setBtnLoading(true);
    ProductApi.create(formData)
      .then((res) => {
        setData([...data, res.product]);
        MessagesService.success("Продукт создан");
        setOpen(false);
        form.resetFields();
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };

  const onEdit = (values) => {
    setBtnLoading(true);
    try {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("price", values.price);
      formData.append("category_id", values.category_id);
      formData.append("description", values.description);
      if (values.sizes?.length) {
        formData.append("sizes", JSON.stringify(values.sizes));
      }
      if (values.photos.fileList?.length) {
        values.photos.fileList.forEach((file) => {
          formData.append("photos", file.originFileObj);
        });
      }
      ProductApi.edit(form.getFieldValue().id, formData)
        .then((res) => {
          MessagesService.success("Продукт обновлен");
          setEdit(false);
          setData(
            data.map((item) =>
              item.id === res.product.id ? res.product : item
            )
          );
          form.resetFields();
          setFileList({ photos: [] });
        })
        .catch((err) => console.log(err))
        .finally(() => setBtnLoading(false));
    } catch (error) {
      console.log(error);
    }
  };

  const onRemove = (id) => {
    ProductApi.delete(id).then((res) => {
      if (res) {
        setData(data.filter((item) => item.id !== id));
        MessagesService.success("Продукт удален");
      }
    });
  };

  // Render
  return (
    <>
      <Card>
        <Row className="justify-between items-center">
          <h4 className="font-semibold text-base">Продукт</h4>
          <Button
            type="primary"
            size="large"
            onClick={() => {
              setFileList({ photos: [] });
              setOpen(true);
              form.resetFields();
            }}
          >
            Создать продукт
          </Button>
        </Row>
      </Card>
      <Card>
        <Table
          columns={columns}
          dataSource={data}
          // scroll={{
          //   x: 2000,
          // }}
          loading={loading}
          // onChange={(p, _, sort) => {
          //   const f = {
          //     ...filter,
          //     page: p.current,
          //     limit: p.pageSize,
          //   };
          //   setFilter(f);
          //   fetch(f);
          // }}
          pagination={
            {
              // current: filter.page,
              // total: data?.total,
              // pageSize: filter.limit,
            }
          }
        />
      </Card>
      <Modal
        title="Создать продукт"
        centered
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        width={800}
        footer={null}
      >
        <FormComponent
          type="create"
          fileList={fileList}
          setFileList={setFileList}
          form={form}
          onFinish={onFinish}
          btnLoading={btnLoading}
          categories={categories}
        />
      </Modal>
      <Modal
        title="Редактировать продукт"
        centered
        open={edit}
        onOk={() => setEdit(false)}
        onCancel={() => setEdit(false)}
        footer={null}
        width={800}
      >
        <FormComponent
          type="edit"
          fileList={fileList}
          setFileList={setFileList}
          form={form}
          onFinish={onEdit}
          btnLoading={btnLoading}
          categories={categories}
        />
      </Modal>
    </>
  );
}
